import { css } from "styled-components";

const ModalSide = css`
	width: 45vw;
	height: 95%;
	min-width: 300px;
	min-height: 600px;
	position: absolute;
	top: 20px;
	right: 20px;
    
    @media (max-width: 340px) { 
        right: 10px;
    }
    @media (max-width: 768px) { 
        width: 80vw;
    }
    @media (min-width: 768px) and (max-width: 992px) { 
        width: 70vw;
    }
    @media (min-width: 992px) and (max-width: 1200px) { 
        width: 55vw;
    }
`;

export const ModalCenter = css`
    width: 70vw;
    min-width: 300px;
    max-height: 90%;
    position: absolute;
    top: 60px;
`;

export default ModalSide;
